import { useTranslation } from "react-i18next";
import {
  getColor,
  getSemanticTranslation,
} from "../../../../pages/postEditor/seoAnalyzer/helper";

export const SemanticsAnalysis = ({ analysis }) => {
  const { t } = useTranslation();
  return (
    <>
      {/* Score Bar */}
       <div className="mt-4">
                  <span className="font-semibold mb-3">
                    {analysis.total_score}%
                    </span>
                    </div>
                  
                  <div className="w-full relative p-2 rounded-xl bg-slate-300 mb-5 mt-1">
                    <div
                      className={`bg-${getColor(
                        analysis.total_score
                      )} h-full rounded-xl absolute top-0 left-0`}
                      style={{ width: `${analysis.total_score}%` }}
                    ></div>
                  </div>

      {/* Keyword Density */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t("Target-keyword-density", "Target keyword density")}{" "}
        </p>
        <p
          className={`${
            analysis?.keyword_density?.score == 100
              ? "text-green-500"
              : analysis?.keyword_density?.score === 50
              ? "text-yellow-400"
              : analysis?.keyword_density?.score == 0
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.keyword_density?.score == 100 && (
            <>
              {`${t(
                "The-target-request-appears-a-good-amount-of-time-in-the-text",
                "The target request appears a good amount of time in the text"
              )} 
                              ( ${
                                Math.round(
                                  analysis?.keyword_density?.wordCount * 1
                                ) / 100
                              }  < ${analysis?.keyword_density.matchCount} <
                                ${Math.round(
                                  (analysis?.keyword_density?.wordCount * 2) /
                                    100
                                )} ).`}
            </>
          )}
          {analysis?.keyword_density?.score == 50 && (
            <>
              {analysis?.keyword_density.percentage >= 0.5 &&
              analysis?.keyword_density.percentage < 1
                ? `${t(
                    "The-target-request-should-appear-a-few-more-times-in-the-text  (",
                    "The target request should appear a few more times in the text  ("
                  )}
                                    ${
                                      analysis?.keyword_density.matchCount
                                    } <  ${Math.round(
                    (analysis?.keyword_density?.wordCount * 1) / 100
                  )} ).`
                : `${t(
                    "The-target-request-should-appear-a-few-less-times-in-the-text  (",
                    "The target request should appear a few less times in the text  ("
                  )}
                                  ${
                                    analysis?.keyword_density.matchCount
                                  } >  ${Math.round(
                    (analysis?.keyword_density?.wordCount * 2) / 100
                  )} ).`}
            </>
          )}

          {analysis?.keyword_density?.score == 0 && (
            <>
              {analysis?.keyword_density.percentage < 0.5
                ? `${t(
                    "The-target-request-does-not-appear-enough-in-the-text (",
                    "The target request does not appear enough in the text ("
                  )}
                                    ${
                                      analysis?.keyword_density.matchCount
                                    } < ${Math.round(
                    (analysis?.keyword_density?.wordCount * 0.5) / 100
                  )} ).`
                : `${t(
                    "The-target-request-appears-too-many-times-in-the-text (",
                    "The target request appears too many times in the text ("
                  )}
                                   ${
                                     analysis?.keyword_density.matchCount
                                   } >  ${Math.round(
                    (analysis?.keyword_density?.wordCount * 3) / 100
                  )} ).`}
            </>
          )}
          {analysis?.keyword_density?.score == -1 && (
            <>
              {analysis?.keyword_density.queryLength == 0
                ? t("Target-request-not-found", "Target request not found")
                : t("Please-add-content", "Please add content")}
            </>
          )}
        </p>
      </div>

      {/* Keyword Placement */}
      <div className="mt-5">
        <p className="text-sm mb-2 font-semibold">
          {t("Target-keyword-placement", "Target keyword placement")}{" "}
        </p>
        <p
          className={`${
            analysis?.keyword_placement?.score == 100
              ? "text-green-500"
              : analysis?.keyword_placement?.score === 50
              ? "text-yellow-400"
              : analysis?.keyword_placement?.score == 0
              ? "text-red-600"
              : "text-gray_local-400"
          } text-sm mb-2 font-semibold`}
        >
          {analysis?.keyword_placement?.score === 100 && (
            <>
              {t(
                "The-target-request-appears-in-introduction,H2-and-conclusion.",
                "The target request appears in introduction, H2 and  conclusion."
              )}
            </>
          )}

          {analysis?.keyword_placement?.score === 50 && (
            <>
              {analysis?.keyword_placement?.checks.filter((item) => item.value)
                .length > 0 &&
                `${t(
                  "The-target-request-appears-in",
                  "The target request appears in"
                )} 
                ${analysis?.keyword_placement?.checks
                  ?.filter((item) => item.value)
                  ?.map((item) => getSemanticTranslation(t, item.name))
                  .join(t(" and ", " and "))}.`}
            </>
          )}
          {analysis?.keyword_placement?.score === 0 && (
            <>
              {analysis?.keyword_placement?.checks?.filter(
                (item) => !item.value
              ).length > 0 && (
                <>
                  {analysis?.keyword_placement.checks.filter(
                    (item) => item.value
                  ).length > 0
                    ? `${t(
                        "The-target-request-appears-in",
                        "The target request appears in "
                      )} 
                    ${analysis?.keyword_placement?.checks
                      ?.filter((item) => item.value)
                      ?.map((item) => getSemanticTranslation(t, item.name))
                      .join(t(" and ", " and "))}${t(
                        ",but-not-in",
                        ", but not in "
                      )}`
                    : t("It-does-not-appear-in", "It does not appear in ")}
                  {analysis?.keyword_placement.checks?.filter(
                    (item) => !item.value
                  ).length > 0 &&
                    `${analysis?.keyword_placement?.checks
                      ?.filter((item) => !item.value)
                      ?.map((item) => getSemanticTranslation(t, item.name))
                      .join(t(" and ", " and "))}. ${t("Add-it!", " Add it!")}`}
                </>
              )}
            </>
          )}
          {analysis?.keyword_placement?.score === -1 && (
            <>
              {analysis?.keyword_placement.queryLength == 0
                ? t("Target-request-not-found", "Target request not found")
                : t("Please-add-content", "Please add content")}
            </>
          )}
        </p>
      </div>
    </>
  );
};
